<template>
  <v-container fluid>
    <h1>{{ get("header-1") }}</h1>
    <br />
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-img :src="image" class="image" alt="Window Image" left></v-img>
        </v-row>
        <v-row>
          <h2>
            {{ get("header-2") }}
          </h2>
          <p>
            {{ get("p-2.1") }}
          </p>
        </v-row>
        <v-row>
          <h2>{{ get("header-3") }}</h2>
          <p>
            {{ get("p-3.1") }}
          </p>
        </v-row>
        <v-row>
          <h2>{{ get("header-4") }}</h2>
          <p>
            {{ get("p-4.1") }}
          </p>
        </v-row>
        <v-row>
          <h2>
            {{ get("header-5") }}
          </h2>
          <p>
            {{ get("p-5.1") }}
          </p>
        </v-row>
        <v-row>
          <h2>{{ get("header-6") }}</h2>
          <p>
            {{ get("p-6.1") }}
          </p>
        </v-row>
        <v-row>
          <h2>{{ get("header-7") }}</h2>
          <p>
            {{ get("p-7.1") }}
          </p>
        </v-row>
        <v-row>
          <h2>
            {{ get("header-8") }}
          </h2>
          <p>
            {{ get("p-8.1") }}
          </p>
        </v-row>
        <v-row>
          <h2>{{ get("header-9") }}</h2>
          <p>
            {{ get("p-9.1") }}
             <phonenumber phone="(719) 390-7663"></phonenumber>
             {{ get("p-9.2") }}
          </p>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "window-energy",

  components: {
    estimate,
    phonenumber
  },

  created() {
    this.pageName = "window-energy";
  },

  data: () => ({
    image: require("@/assets/windows-2.jpg"),
  }),

  mixins: [localizationMixin],

  methods: {
    getLocalization(){}
  },
};
</script>

<style lang="scss" scoped>

.image {
  margin-bottom: 20px;
}
</style>
